module.exports = __webpack_public_path__ + "img/woff.b27df5c1.svg";